<template>
  <div class="work-type-page">
    <Button type="primary" icon="plus-round" v-if="permissions === true" @click="edit(0)">{{$t("system.workType.New_workType")}}</Button>
    <Button type="primary" icon="plus-round" v-if="permissions !== true" @click="edit(0)" disabled>{{$t("system.workType.New_workType")}}</Button>
    <el-table class="work-type-table" highlight-row stripe border :data="datas">
      <el-table-column type="index" :label="$t('system.workType.Sorting')" width="85px"></el-table-column>
      <el-table-column prop="name" :label="$t('system.workType.name')"></el-table-column>
      <el-table-column prop="outputValidName" :label="$t('system.workType.outputValid')">{{$t('system.workType.yes')}}</el-table-column>
      <el-table-column prop="monopolyName" :label="$t('system.workType.monopoly')"></el-table-column>
      <el-table-column prop="maintainName" :label="$t('system.workType.maintain')"></el-table-column>
      <el-table-column prop="displayName" :label="$t('system.workType.display')"></el-table-column>
      <el-table-column prop="malfunctionName" :label="$t('system.workType.malfunction')"></el-table-column>
      <el-table-column prop="remark" :label="$t('system.workType.remark')"></el-table-column>
      <el-table-column :label="$t('system.workType.operating')" width="150px">
        <template slot-scope="scope" >
          <el-button v-if="permissions === true" @click.native="edit(scope.row.id)" type="primary" size="small">{{$t('system.workType.edit')}}</el-button>
          <el-button v-if="permissions === true" @click.native="remove(scope.row.id, scope.$index)" type="danger" size="small">{{$t('system.workType.delete')}}</el-button>
          <el-button v-if="permissions !== true" type="primary" size="small" disabled>{{$t('system.workType.edit')}}</el-button>
          <el-button v-if="permissions !== true" type="danger" size="small" disabled>{{$t('system.workType.delete')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <Table class="work-type-table" highlight-row stripe border :columns="columns" :data="datas"></Table> -->
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'workType',
  data () {
    return {
      // columns: [
      //   // { type: 'index', title: this.$t('system.workType.index') },
      //   { title: this.$t('system.workType.Sorting'), key: 'Sorting', sortable: true, sortType: 'asc' },
      //   { title: this.$t('system.workType.name'), key: 'name' },
      //   { title: this.$t('system.workType.outputValid'),
      //     key: 'outputValid',
      //     render: (h, params) => {
      //       let b = params.row.outputValid === 0 ? this.$t('system.workType.no') : this.$t('system.workType.yes')
      //       return h('span', b)
      //     }
      //   },
      //   { title: this.$t('system.workType.monopoly'),
      //     key: 'monopoly',
      //     render: (h, params) => {
      //       let b = params.row.monopoly === 0 ? this.$t('system.workType.no') : this.$t('system.workType.yes')
      //       return h('span', b)
      //     }
      //   },
      //   { title: this.$t('system.workType.maintain'),
      //     key: 'maintain',
      //     render: (h, params) => {
      //       let b = params.row.maintain === 0 ? this.$t('system.workType.no') : this.$t('system.workType.yes')
      //       return h('span', b)
      //     }
      //   },
      //   { title: this.$t('system.workType.display'),
      //     key: 'display',
      //     render: (h, params) => {
      //       let b = params.row.display === 0 ? this.$t('system.workType.no') : this.$t('system.workType.yes')
      //       return h('span', b)
      //     }
      //   },
      //   { title: this.$t('system.workType.malfunction'),
      //     key: 'malfunction',
      //     render: (h, params) => {
      //       let b = params.row.malfunction === 0 ? this.$t('system.workType.no') : this.$t('system.workType.yes')
      //       return h('span', b)
      //     }
      //   },
      //   // { title: this.$t('system.workType.warn'),
      //   //   key: 'warn',
      //   //   render: (h, params) => {
      //   //     let b = params.row.warn === 0 ? this.$t('system.workType.yes') : this.$t('system.workType.no')
      //   //     return h('span', b)
      //   //   }
      //   // },
      //   { title: this.$t('system.workType.remark'), key: 'remark' },
      //   {
      //     title: this.$t('system.workType.operating'),
      //     key: 'action',
      //     render: (h, params) => {
      //       if (params.index >= 4 && this.permissions === true) {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.edit(params.index)
      //               }
      //             }
      //           }, this.$t('system.workType.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'error',
      //               size: 'small'
      //             },
      //             on: {
      //               click: () => {
      //                 if (confirm(this.$t('system.workType.delete_message'))) {
      //                   this.remove(params.index)
      //                 }
      //               }
      //             }
      //           }, this.$t('system.workType.delete'))
      //         ])
      //       } else if (this.permissions === true) {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.edit(params.index)
      //               }
      //             }
      //           }, this.$t('system.workType.edit'))
      //         ])
      //       } else {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small',
      //               disabled: true
      //             },
      //             style: {
      //               marginRight: '5px'
      //             }
      //           }, this.$t('system.workType.edit'))
      //         ])
      //       }
      //     }
      //   }
      // ],
      datas: [],
      permissions: false
    }
  },
  methods: {
    edit (id) {
      // id === -1 ? 0 : id
      this.$router.push({ name: 'WorkTypeEdit', params: { id } })
    },
    remove (id, index) {
      if (confirm(this.$t('system.workType.delete_message'))) {
        this.$api.workType.delete(id).then(() => {
          this.datas.splice(index, 1)
        })
      }
    }
  },
  mounted () {
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'system' && res.user.permissions[i].value === 3) {
          this.permissions = true
        }
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    Api.workType.list().then(res => {
      next(vm => {
        vm.datas = res.workTypes
        for (let i = 0; i < vm.datas.length; i++) {
          vm.datas[i].outputValidName = vm.datas[i].outputValid === 0 ? vm.$t('system.workType.no') : vm.$t('system.workType.yes')
          vm.datas[i].monopolyName = vm.datas[i].monopoly === 0 ? vm.$t('system.workType.no') : vm.$t('system.workType.yes')
          vm.datas[i].maintainName = vm.datas[i].maintain === 0 ? vm.$t('system.workType.no') : vm.$t('system.workType.yes')
          vm.datas[i].displayName = vm.datas[i].display === 0 ? vm.$t('system.workType.no') : vm.$t('system.workType.yes')
          vm.datas[i].malfunctionName = vm.datas[i].malfunction === 0 ? vm.$t('system.workType.no') : vm.$t('system.workType.yes')
          // console.log(vm.datas[i])
        }
        console.log(vm.datas)
      })
    })
  }
}
</script>
<style scoped>
  .work-type-page {
    padding: 10px;
  }

  .work-type-table {
    margin-top: 20px;
  }
</style>





// WEBPACK FOOTER //
// List.vue?3a468ba3